"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const history_1 = require("history");
const react_router_config_1 = require("react-router-config");
const match_1 = require("./match");
const render_1 = require("./render");
class Chyk {
    constructor(props) {
        this._el = null;
        this.onLoadError = err => {
            throw err;
        };
        this.staticRouterContext = {};
        this.locationStates = {};
        this.location = { pathname: "" };
        this.loadData = (_location) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const abortController = this.isBrowser
                    ? new AbortController()
                    : { signal: { aborted: false } }; // mock on server
                const location = typeof _location === "string" ? history_1.createLocation(_location) : _location;
                const { pathname } = location;
                const matches = react_router_config_1.matchRoutes(this.routes, pathname);
                this.upsertLocationStateLoading(abortController, pathname, matches, location);
                const [data] = yield Promise.all([
                    match_1.loadBranchDataObject(this, matches, abortController),
                    match_1.loadBranchComponents(matches),
                ]);
                this.location = location;
                this.updateLocationStateLoaded(pathname, data);
                return true;
            }
            catch (err) {
                if (err.name === "AbortError") {
                    // request was aborted, so we don't care about this error
                    // console.log("AbortError", err)
                }
                else {
                    this.onLoadError(err);
                }
                return false;
            }
        });
        this.set404 = () => {
            this.setStatus(404);
        };
        this.handleLocationChange = (new_location) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const location = this.locationState.location;
            if (location.pathname === new_location.pathname) {
                return false;
            }
            this.abortLoading();
            if (this.getLocationState(new_location.pathname)) {
                return false;
            }
            const is_success = yield this.loadData(new_location);
            this.cleanLocationState(is_success ? location.pathname : new_location.pathname);
            return true;
        });
        this.routes = props.routes;
        this.deps = props.deps;
        this.component = props.component;
        this._el = props.el;
        this.history = props.history ? props.history : props.el ? history_1.createBrowserHistory() : null;
        if (props.onLoadError) {
            this.onLoadError = props.onLoadError;
        }
        if (this.history) {
            this.location = this.history.location;
            this.mergeLocationState(this.location.pathname, Object.assign({ data: props.data, location: this.history.location }, (props.statusCode ? { statusCode: props.statusCode } : null)));
            this.loadAndRender(Boolean(props.data));
        }
    }
    get el() {
        if (!this._el) {
            throw "No element";
        }
        return this._el;
    }
    get isBrowser() {
        return Boolean(this.history);
    }
    get loading() {
        return Object.values(this.locationStates).some(state => state.loading);
    }
    loadAndRender(disableDataLoading) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.history) {
                throw "No history";
            }
            if (!disableDataLoading) {
                yield this.loadData(this.history.location);
            }
            else {
                const matches = react_router_config_1.matchRoutes(this.routes, this.history.location.pathname);
                yield match_1.loadBranchComponents(matches);
            }
            render_1.chykHydrateOrRender(this);
        });
    }
    upsertLocationStateLoading(abortController, pathname, matches, location) {
        this.mergeLocationState(pathname, {
            matches,
            pathname,
            location,
            abortController,
            statusCode: 200,
            loading: true,
        });
    }
    updateLocationStateLoaded(pathname, data) {
        this.mergeLocationState(pathname, {
            data,
            loading: false,
        });
    }
    mergeLocationState(pathname, state) {
        const _state = this.locationStates[pathname] || {};
        this.locationStates[pathname] = Object.assign(_state, state);
    }
    getLocationState(pathname) {
        return this.locationStates[pathname];
    }
    get locationState() {
        return this.locationStates[this.location.pathname];
    }
    get statusCode() {
        return this.locationState.statusCode;
    }
    get data() {
        return this.locationState.data;
    }
    cleanLocationState(pathname) {
        delete this.locationStates[pathname];
    }
    abortLoading() {
        Object.values(this.locationStates).forEach(state => {
            state.abortController && state.abortController.abort();
            state.loading = false;
        });
    }
    get is404() {
        return this.statusCode === 404;
    }
    setStatus(statusCode) {
        Object.values(this.locationStates).forEach(state => {
            if (state.loading) {
                state.statusCode = statusCode;
            }
        });
    }
}
exports.Chyk = Chyk;
//# sourceMappingURL=chyk.js.map